"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
var END_TOKEN = 'E';
var START = 'start';
var PARAMS = { M: 2, m: 2, L: 2, l: 2, C: 6, c: 6, Z: 0, z: 0 };
var curveTokens = ['C', 'c'];
var loopTokens = ['Z', 'z'];
var TOKEN;
(function (TOKEN) {
    TOKEN[TOKEN["command"] = 0] = "command";
    TOKEN[TOKEN["num"] = 1] = "num";
    TOKEN[TOKEN["eod"] = 2] = "eod";
})(TOKEN || (TOKEN = {}));
var XmlToSvg = /** @class */ (function () {
    function XmlToSvg(path) {
        this.segments = [];
        this.serializeStr = path || '';
        this.parsePath();
    }
    /**
     * 解析path路径 为 路径片段数组，并挂在到实例属性this.segments上
     * @returns 返回实例本身，以便于于链式调用
     * 示例： const xts = new XmlToSvg('M 0 0 L 10 20');
     * console.log(xts.parsePath())
     * 输出为 {segments:[{key:'M', data:[0 ,0] },{key:'L', data:[10 ,20]}], serializeStr: "M0 0 L10 20 "}
     */
    XmlToSvg.prototype.parsePath = function () {
        try {
            if (!this.serializeStr)
                return this;
            if (this.segments.length) {
                this.segments = [];
            }
            var tokens = this.tokenize(this.serializeStr);
            var mode = START;
            var index = 0;
            var token = tokens[index];
            while (!this.isType(token, TOKEN.eod)) {
                var paramsCount = 0;
                var pointObj = this.handlePointStatus({ mode: mode, index: index, count: paramsCount }, token);
                mode = pointObj === null || pointObj === void 0 ? void 0 : pointObj.mode;
                paramsCount = pointObj === null || pointObj === void 0 ? void 0 : pointObj.count;
                index = this.handleSegment(pointObj, tokens);
                token = tokens[index];
            }
            return this;
        }
        catch (error) {
            console.log('error: ', error);
            return this;
        }
    };
    /**
     * 将路径片段数组序列化为路径字符串
     * @returns 返回实例本身，便于链式调用
     * 示例： const xts = new XmlToSvg('M 0 0 L 10 20');
     * console.log(xts.parsePath().serialize())
     * 输出为 {segments:[{key:'M', data:[0 ,0] },{key:'L', data:[10 ,20]}], serializeStr: "M0 0 L10 20 "}
     */
    XmlToSvg.prototype.serialize = function () {
        if (!this.segments.length)
            return this;
        this.serializeStr = this.handleTokens().join(' ');
        return this;
    };
    /**
     * 将路径对应的数值按比例放大或缩小
     * @returns 返回实例本身，便于链式调用
     * 示例： const xts = new XmlToSvg('M 0 0 L 10 20');
     * console.log(xts.parsePath().scale(10，200))
     * 输出为 {segments:[{key:'M', data:[0 ,0] },{key:'L', data:[100 ,4000]}], serializeStr: "M0 0 L100 4000 "}
     */
    XmlToSvg.prototype.scale = function (sx, sy) {
        if (!this.segments.length)
            return this;
        var yRate = typeof sy === 'undefined' ? sx : sy;
        this.segments.forEach(function (segment) {
            var _a = segment.data, data = _a === void 0 ? [] : _a;
            data.forEach(function (_value, i) {
                data[i] *= i % 2 ? yRate : sx;
            });
        });
        this.serialize();
        return this;
    };
    /**
     * 将路径对应的数值进行位移
     * @returns 返回实例本身，便于链式调用
     * 示例： const xts = new XmlToSvg('M 0 0 L 10 20');
     * console.log(xts.parsePath().translate(10，200))
     * 输出为 {segments:[{key:'M', data:[0 ,0] },{key:'L', data:[20 ,220]}], serializeStr: "M0 0 L10 220 "}
     */
    XmlToSvg.prototype.translate = function (tx, ty) {
        if (!this.segments.length)
            return this;
        var yStep = ty || 0;
        this.segments.forEach(function (segment) {
            var _a = segment.data, data = _a === void 0 ? [] : _a;
            data.forEach(function (_value, i) {
                data[i] += i % 2 ? yStep : tx;
            });
        });
        this.serialize();
        return this;
    };
    /**
     * 获取路径中第一个点位的坐标值
     * @returns {xPos:x轴坐标值,yPos:y轴坐标值}
     */
    XmlToSvg.prototype.getFirstPointPosition = function () {
        if (!this.segments.length)
            return { xPos: 0, yPos: 0 };
        var firstPoint = this.segments[0];
        var _a = firstPoint.data, data = _a === void 0 ? [] : _a;
        var _b = data[0], xPos = _b === void 0 ? 0 : _b, _c = data[1], yPos = _c === void 0 ? 0 : _c;
        return { xPos: xPos, yPos: yPos };
    };
    /**
     * 获取路径中最后一个点位的坐标值
     * TODO 需要考虑相对位移，目前没有考虑
     * @returns {xPos:x轴坐标值,yPos:y轴坐标值}
     */
    XmlToSvg.prototype.getEndPointPosition = function () {
        var segmentsLength = this.segments.length;
        if (!segmentsLength)
            return { xPos: 0, yPos: 0 };
        var lastPoint = this.segments[segmentsLength - 1];
        var _a = lastPoint.key, key = _a === void 0 ? '' : _a, _b = lastPoint.data, data = _b === void 0 ? [] : _b;
        if (loopTokens.includes(key)) {
            return this.getFirstPointPosition();
        }
        var newData = __spreadArray([], data);
        if (curveTokens.includes(key)) {
            newData = newData.slice(-2);
        }
        var _c = newData[0], xPos = _c === void 0 ? 0 : _c, _d = newData[1], yPos = _d === void 0 ? 0 : _d;
        return { xPos: xPos, yPos: yPos };
    };
    /**
     * 去除path收尾空格，以及如果以E结尾，去掉E
     * @param path
     * @returns path
     */
    XmlToSvg.prototype.trimEndToken = function (path) {
        var d = path.trim();
        if (d[d.length - 1] === END_TOKEN) {
            d = d.slice(0, d.length - 1);
        }
        return d;
    };
    XmlToSvg.prototype.tokenize = function (path) {
        var d = this.trimEndToken(path);
        var tokens = [];
        while (d !== '') {
            if (d.match(/^([ \t\r\n,]+)/)) {
                d = d.substr(RegExp.$1.length);
            }
            else if (d.match(/^([cClLmMqzZ])/)) {
                tokens[tokens.length] = { type: TOKEN.command, text: RegExp.$1 };
                d = d.substr(RegExp.$1.length);
            }
            else if (d.match(/^(([-+]?[0-9]+(\.[0-9]*)?|[-+]?\.[0-9]+)([eE][-+]?[0-9]+)?)/)) {
                tokens[tokens.length] = { type: TOKEN.num, text: "" + parseFloat(RegExp.$1) };
                d = d.substr(RegExp.$1.length);
            }
            else {
                return [];
            }
        }
        tokens[tokens.length] = { type: TOKEN.eod, text: '' };
        return tokens;
    };
    XmlToSvg.prototype.isM = function (token) {
        return token.text === 'M' || token.text === 'm';
    };
    XmlToSvg.prototype.isType = function (token, type) {
        return token.type === type;
    };
    XmlToSvg.prototype.handleStartToken = function (index, token) {
        if (!this.isM(token)) {
            throw new Error('Path needs start with M or m Command');
        }
        return {
            index: index + 1,
            count: PARAMS[token.text],
            mode: token.text,
        };
    };
    XmlToSvg.prototype.handlePointStatus = function (point, token) {
        if ((point === null || point === void 0 ? void 0 : point.mode) === START) {
            return this.handleStartToken(point === null || point === void 0 ? void 0 : point.index, token);
        }
        if (this.isType(token, TOKEN.num)) {
            return __assign(__assign({}, point), { count: PARAMS[point === null || point === void 0 ? void 0 : point.mode] });
        }
        return {
            index: (point === null || point === void 0 ? void 0 : point.index) + 1,
            count: PARAMS[token.text],
            mode: token.text,
        };
    };
    XmlToSvg.prototype.handleSegmentData = function (point, tokens) {
        var mode = point.mode, count = point.count, index = point.index;
        var data = [];
        for (var i = index; i < index + count; i++) {
            var numberToken = tokens[i];
            if (!this.isType(numberToken, TOKEN.num)) {
                throw new Error(" Param not a number:" + mode + numberToken.text);
            }
            data[data.length] = Number(numberToken.text);
        }
        return data;
    };
    XmlToSvg.prototype.handleSegment = function (point, tokens) {
        var mode = point.mode, index = point.index, count = point.count;
        if (index + count >= tokens.length) {
            throw new Error('Path data is not correct, please check its length');
        }
        if (typeof PARAMS[mode] !== 'number') {
            throw new Error("Bad segment: " + mode);
        }
        var segment = { key: mode, data: this.handleSegmentData(point, tokens) };
        this.segments.push(segment);
        return index + count;
    };
    XmlToSvg.prototype.handleTokens = function () {
        var tokens = [];
        this.segments.forEach(function (segment) {
            var key = segment.key, data = segment.data;
            tokens.push(key);
            switch (key) {
                case 'C':
                case 'c':
                    tokens.push(data[0], data[1], data[2], data[3], data[4], data[5]);
                    break;
                default:
                    tokens.push.apply(tokens, data);
                    break;
            }
        });
        return tokens;
    };
    return XmlToSvg;
}());
exports.default = XmlToSvg;
